import * as React from 'react';
import NumberFormat from 'react-number-format';
import Select from 'react-select';
import CreatableSelect from 'react-select/creatable';
import { Button, Col, Form, FormFeedback, FormGroup, Input, Label, Row} from 'reactstrap';
import { ProjectTypeConfig, ProjectTypeList } from 'src/components/shared/Input/ProjectTypeList';
import { functionalSkillsItems, sectorItems ,technicalSkillsItems } from 'src/config';
import { IGlobalContextProps, withGlobalContext } from 'src/context/global.context';
// import { SectorType } from 'src/model';
import { /* sendActivationEmail,*/updateUser } from 'src/services';
import { UploadResumeWithGlobalContext } from './UploadResume';


interface IConsultantModalProps {
  changeStep: (stepNumber: number) => void;
  toggleCreateConsultantModal: () => void;
  toggleSignupConfirmationModal: () => void;
}

const CreateConsultantThirdStep: React.SFC<
  IConsultantModalProps & IGlobalContextProps
> = ({
  changeStep,
  context,
  toggleCreateConsultantModal,
  toggleSignupConfirmationModal,
}) => {
 
  
  const [state, setState] = React.useState({
    globalInvalid : false,
    invalid: false,
    profile: {
      certification: [],
      dailyPriceMax: undefined,
      dailyPriceMin: undefined,
      education: [],
      experience: [],
      functionalSkills: undefined,
      projectType: [],
      sector: undefined,
      technicalSkills: undefined,
    },
  });
  const isValid = state.profile.projectType.length > 0  && !!state.profile.dailyPriceMin;


  const handleProfileChange = (e: React.ChangeEvent<Element>) => {
    setState({
      ...state,
      profile: {
        ...state.profile,
        [(e.target as any).name]: (e.target as any).value,
      },
    });
  };

/* A optimiser   **********************************************/
  const handleChangeMultiFunctionalSkills = (functionalSkills: any) => {
    setState({
      ...state,
      profile: {
        ...state.profile,
        functionalSkills
      }, 
    });
  };

  const handleChangeMultiTechnicalSkills = (technicalSkills: any) => {
    setState({
      ...state,
      profile: {
        ...state.profile,
        technicalSkills
      }, 
    });
  };

  const handleChangeMultiSector = (sector: any) => {
    setState({
      ...state,
      profile: {
        ...state.profile,
        sector
      }, 
    });
  };
/**************************************************************************/


  const handleClick = (id: string) => {
    const label = ProjectTypeConfig[id].label;
    const index = (state.profile.projectType as any).indexOf(label);
    const projectType = state.profile.projectType.slice();

    if (index === -1) {
      if (projectType.length < 3) {
        (projectType as any).push(label);
        setState({
          ...state,
          invalid: false,
          profile: { ...state.profile, projectType },
        });
      } else {
        setState({ ...state, invalid: true });
      }
    } else {
      if (projectType.length !== 1) {
        projectType.splice(index, 1);
        setState({
          ...state,
          invalid: false,
          profile: { ...state.profile, projectType },
        });
      }
    }
  };

  const handleSave = async () => {
    if (isValid) {
      /***************** */ 
      const experience = state.profile.experience;
      (experience as any).push({ title: '', company: '', startDate: null , endDate: null, description: ''});

      const education = state.profile.education;
      (education as any).push({ school: '', title: '', startDate: null , endDate: null});

      const certification = state.profile.certification;
      (certification as any).push({ title: '', obtainDate: null });
      /***************** */ 
      const updatedUser = await updateUser({ profile: state.profile });
      if (updatedUser) {
        /***************** */ 
        context.updateUser();
        /***************** */
       // sendActivationEmail();
        localStorage.removeItem('beadvize-IsCreating');
        context.toggleIsCreating();
        changeStep(1);
        toggleCreateConsultantModal();
        toggleSignupConfirmationModal();
      }
    } else {
      setState({
        ...state,
        globalInvalid: true,
      });
    }
  };

  const previousStep = () => {
    changeStep(2);
  };

  return (
    <Form className='p-5'>
      <FormGroup>
        <span className='d-block font-weight-bolder mb-3'>
          Domaine d'intervention*
        </span>
        <ProjectTypeList
          edit={true}
          projectType={state.profile.projectType}
          handleClick={handleClick}
        />
        <Input invalid={state.invalid || state.globalInvalid} style={{ display: 'none' }} />
        <FormFeedback>
          {
          state.profile.projectType.length === 0 ? `Merci de sélectionner au moins un domaine d'intervention` :

          (
            (state.globalInvalid && state.profile.projectType.length > 0 ) ?  (state.invalid ? `Vous ne pouvez sélectionner que 3 domaines d'intervention`: null) 
            
            :  `Vous ne pouvez sélectionner que 3 domaines d'intervention`
          )
           
           }
        </FormFeedback>
      </FormGroup>
      <FormGroup>
        <Select
            name="sector"
            classNamePrefix="form-control"
            isMulti={true} 
            closeMenuOnSelect = {true}
            options={sectorItems}
            noOptionsMessage={() => 'Item non disponible'}
            placeholder="Secteur d'activité"    
            value={ state.profile.sector ? state.profile.sector : null}
            onChange={handleChangeMultiSector}
              />
      </FormGroup>
      <Row className='d-flex justify-content-between'>
        <Col md='6' xs='auto'>
          <FormGroup>
            <Input
              type='text'
              name='dailyPriceMin'
              placeholder='Tarif jour min*'
              value={state.profile.dailyPriceMin}
              onChange={handleProfileChange}
              tag={NumberFormat}
              thousandSeparator={' '}
              invalid={state.globalInvalid && !!!state.profile.dailyPriceMin}
            />
            <FormFeedback>
              Merci de renseigner un tarif journalier minimun
            </FormFeedback>
          </FormGroup>
        </Col>
        <Col md='6' xs='auto'>
          <FormGroup>
            <Input
              type='text'
              name='dailyPriceMax'
              placeholder='Tarif jour max'
              value={state.profile.dailyPriceMax}
              onChange={handleProfileChange}
              tag={NumberFormat}
              thousandSeparator={' '}
            />
          </FormGroup>
        </Col>
      </Row>
      <FormGroup>
        <CreatableSelect
            name="functionalSkills"
            classNamePrefix="form-control"
            isMulti={true} 
            closeMenuOnSelect = {true}
            options={functionalSkillsItems}
            noOptionsMessage={() => 'Item non disponible'}
            placeholder='Compétences fonctionnelles'    
            value={state.profile.functionalSkills}
            onChange={handleChangeMultiFunctionalSkills}
            formatCreateLabel={value => `Ajouter  "${value}"`}
            createOptionPosition='first'
          />
      </FormGroup>
      <FormGroup>
         <CreatableSelect
            name="technicalSkills"
            classNamePrefix="form-control"
            isMulti={true} 
            closeMenuOnSelect = {true}
            options={technicalSkillsItems}
            noOptionsMessage={() => 'Item non disponible'}
            placeholder='Compétences techniques'    
            value={state.profile.technicalSkills}
            onChange={handleChangeMultiTechnicalSkills}
            formatCreateLabel={value => `Ajouter  "${value}"`}
            createOptionPosition='first'
          />
      </FormGroup>
      <FormGroup>
        <Label>Uploadez votre CV</Label>
        <UploadResumeWithGlobalContext />
      </FormGroup>
      <FormGroup>
        <span className='d-block mb-3'>
          * Champs obligatoires 
        </span>
      </FormGroup>
      <Row className='d-flex justify-content-end'>
        <Col xs='6'>
          <Button
            className='text-uppercase text-white bg-dark border-0 mt-3'
            onClick={previousStep}
          >
            {'< Retour'}
          </Button>
        </Col>
        <Col xs='6'>
          <Button
            className='text-uppercase text-white bg-secondary float-right border-0 mt-3'
            onClick={handleSave}
          >
            Valider
          </Button>
        </Col>
      </Row>
      <Row>
        <Col>
        <span className='d-block mt-3'  style={{fontSize : '0.7rem'}} >
            En cliquant sur Valider, je déclare accepter les Conditions Générales d'Utilisation.
        </span>
      </Col>
      </Row>
    </Form>
  );
};

export const CreateConsultantThirdStepWithGlobalContext = withGlobalContext(
  CreateConsultantThirdStep
);



// WEBPACK FOOTER //
// ./src/components/shared/Modals/CreateConsultantModal/CreateConsultantThirdStep.tsx